'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbagAddonMarkdown = require('bumbag-addon-markdown');
var bumbag = require('bumbag');
var constants = require('@medipass/utils/constants');
var statusTextClasses = require('@medipass/utils/claim-payment-status-text-classes');
var Transactions_components_consumer_StatusText = require('./StatusText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var statusTextClasses__default = /*#__PURE__*/_interopDefaultLegacy(statusTextClasses);

var _templateObject, _TROUBLESHOOT_LINKS;
var FunderError = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  border-left: 2px solid #af0120;\n  margin-left: 4px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  padding-left: 12px;\n"])));
var CLAIM_STATUS_ICON = {
  rejected: 'fas fa-exclamation-circle'
};
var TROUBLESHOOT_LINKS = (_TROUBLESHOOT_LINKS = {}, _TROUBLESHOOT_LINKS[constants.GATEWAY_CODES.HICAPS_ERROR] = 'http://help.medipass.com.au/troubleshooting/error-12', _TROUBLESHOOT_LINKS[constants.GATEWAY_CODES.HICAPS_DOWN] = 'http://help.medipass.com.au/troubleshooting/health-fund-down-error-91', _TROUBLESHOOT_LINKS);
var statusDescriptions = {
  UNDER_REVIEW: /*#__PURE__*/React__default["default"].createElement(bumbag.Alert, {
    variant: "tint",
    type: "warning",
    width: "100%",
    title: "Your Medicare claim has been delayed"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Paragraph, null, "This claim has been referred to a Medicare Customer Services Officer for further assessment."), /*#__PURE__*/React__default["default"].createElement(bumbag.Paragraph, null, "You should still pay the service provider with the details listed below."), /*#__PURE__*/React__default["default"].createElement(bumbag.Paragraph, null, "Contact Medicare for more information on ", /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    fontWeight: "semibold"
  }, "132011"), ".")),
  MEDICARE_DOWN: /*#__PURE__*/React__default["default"].createElement(bumbag.Alert, {
    variant: "tint",
    type: "warning",
    width: "100%",
    title: "Your Medicare claim has been delayed"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Paragraph, null, "This claim has not been processed as the Medicare system is not responding. The claim will be automatically resubmitted on your behalf at another stage."), /*#__PURE__*/React__default["default"].createElement(bumbag.Paragraph, null, "You should still pay the service provider with the details listed below. Once the Medicare claim is processed we will send you a notification."), /*#__PURE__*/React__default["default"].createElement(bumbag.Paragraph, null, "Contact Medicare for more information on ", /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    fontWeight: "semibold"
  }, "132011"), "."))
};

var ClaimStatus = function ClaimStatus(_ref) {
  var description = _ref.description,
      funderMessage = _ref.funderMessage,
      gatewayCode = _ref.gatewayCode,
      status = _ref.status;
  var statusDescription = /*#__PURE__*/React__default["default"].createElement(Transactions_components_consumer_StatusText["default"], {
    description: description // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    ,
    statusTextClass: statusTextClasses__default["default"][status] // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    ,
    statusIcon: CLAIM_STATUS_ICON[status]
  });

  if (gatewayCode && gatewayCode === constants.GATEWAY_CODES.MEDICARE_DOWN) {
    statusDescription = statusDescriptions.MEDICARE_DOWN;
  } else if (status === constants.TRANSACTION_STATUSES.UNDER_REVIEW) {
    statusDescription = statusDescriptions.UNDER_REVIEW;
  } else if (gatewayCode && (gatewayCode === '0' || gatewayCode === '00')) {
    // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type 'Elemen... Remove this comment to see the full error message
    statusDescription = undefined;
  }

  if (!statusDescription && !funderMessage) return null;
  return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, statusDescription, gatewayCode && (gatewayCode === constants.GATEWAY_CODES.HICAPS_DOWN || gatewayCode === constants.GATEWAY_CODES.HICAPS_ERROR) && /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
    href: TROUBLESHOOT_LINKS[gatewayCode],
    target: "_blank",
    rel: "noopener noreferrer"
  }, "What does this mean?"), funderMessage && /*#__PURE__*/React__default["default"].createElement(FunderError, {
    className: "has-text-weight-semibold"
  }, /*#__PURE__*/React__default["default"].createElement(bumbagAddonMarkdown.Markdown, {
    elementProps: {
      a: {
        target: '_blank'
      }
    },
    content: funderMessage
  })));
};

ClaimStatus.defaultProps = {
  funderMessage: undefined,
  gatewayCode: undefined
};

exports["default"] = ClaimStatus;
